import React from "react";
const onboardingPhone = "https://d1vqw4it8x9uac.cloudfront.net/admin/onboarding-phone-1790236892.png";

function RevampProfessionalsOnboarding() {
  return (
    <section className="revamp-section-shell revamp-onboarding-shell" aria-label="Simple onboarding">
      <div className="revamp-onboarding-grid">
        <div className="revamp-onboarding-copy">
          <div className="revamp-profiles-eyebrow">Simple Onboarding</div>
          <h2 className="revamp-onboarding-heading">
            Build your HYNT
            <br />
            business profile in just
            <br />
            <span className="revamp-onboarding-accent">7–10 minutes</span>
          </h2>
          <p className="revamp-onboarding-subcopy">
          Everything homeowners need to discover, trust and <br /> contact you.
          </p>
        </div>

        <div className="revamp-onboarding-media" aria-hidden="true">
          <img className="revamp-onboarding-phone" src={onboardingPhone} alt="" />
        </div>
      </div>
    </section>
  );
}

export default RevampProfessionalsOnboarding;

